import React from 'react';
import {BaseMixin, ElementaryMixin, ContentMixin, ColorSchemaMixin, NestingLevelMixin} from '../common/common.js';
import Environment from '../environment/environment.js';

import './progress-bar-item.less';

export default React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    ContentMixin,
    ColorSchemaMixin,
    NestingLevelMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.ProgressBar.Item',
    nestingLevelList: Environment.getNestingLevelList('bigBoxCollection', 'smallBox'),
    classNames: {
      main: 'uu5-bricks-progress-bar-item progress-bar',
      striped: 'progress-bar-striped',
      active: 'active'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    progress: React.PropTypes.number,
    striped: React.PropTypes.bool,
    animated: React.PropTypes.bool
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      progress: 0,
      striped: false,
      animated: false
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  getInitialState: function () {
    return {
      progress: this.props.progress,
      content: this.getContent(),
      striped: this.props.striped,
      animated: this.props.animated
    };
  },

  componentWillReceiveProps(nextProps){
    if(nextProps.controlled){
      this.setState({
        progress: nextProps.progress,
        content: nextProps.content,
        striped: nextProps.striped,
        animated: nextProps.animated
      });
    }
    return this;
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  getProgress: function () {
    return this.state.progress;
  },

  getProgressContent: function () {
    return this.state.content;
  },

  isStriped: function () {
    return this.state.striped;
  },

  isAnimated: function () {
    return this.state.animated;
  },

  setProgress: function (params, setStateCallback) {
    var newProgress = this._checkProgress(params.value);

    var newState = {
      progress: newProgress
    };

    params.content !== undefined && (newState.content = params.content);
    params.striped !== undefined && (newState.striped = params.striped);
    params.animated !== undefined && (newState.animated = params.animated);
    params.colorSchema !== undefined && (newState.colorSchema = params.colorSchema);

    this.setState(newState, setStateCallback);
    return this;
  },

  increase: function (params, setStateCallback) {
    var progressItem = this;
    this.setState(function (state) {
      var newProgress = progressItem._checkProgress(state.progress + params.value);

      var newState = {
        progress: newProgress
      };

      params.content !== undefined && (newState.content = params.content);
      params.striped !== undefined && (newState.striped = params.striped);
      params.animated !== undefined && (newState.animated = params.animated);
      params.colorSchema !== undefined && (newState.colorSchema = params.colorSchema);

      return newState;
    }, setStateCallback);
    return this;
  },

  decrease: function (params, setStateCallback) {
    if (typeof params === 'number') {
      params = -params;
    } else {
      params.value = -params.value;
    }

    this.increase(params, setStateCallback);
    return this;
  },
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _checkProgress: function (newProgress) {
    var result = newProgress;
    if (newProgress > 100) {
      result = 100;
    } else if (newProgress < 0) {
      result = 0;
    }
    return result;
  },

  _getMainAttrs: function () {
    var mainAttrs = this.buildMainAttrs();

    if (this.isAnimated()) {
      mainAttrs.className += ' ' + this.getClassName().striped + ' ' + this.getClassName().active;
    } else if (this.isStriped()) {
      mainAttrs.className += ' ' + this.getClassName().striped;
    }

    mainAttrs.style = {width: this.getProgress() + '%'};

    return mainAttrs;
  },

  _getChildren: function () {
    var children;

    if (this.getProgress() > 0 && this.getProgressContent() !== '') {
      children = this.getProgressContent() || this.getProgress() + ' %';
    }

    return children;
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return (
      this.getNestingLevel()
        ? (
          <div {...this._getMainAttrs()}>
            {this._getChildren()}
          </div>
        ) : null
    );
  }
  //@@viewOff:render
});



// WEBPACK FOOTER //
// ./bricks/progress-bar-item.js